import React, { useState, useEffect } from 'react';
import { Layout, Row, Col, Form, Select, Input, Button, message, Modal } from 'antd';
import axios from 'axios';
import { useUser } from '../context/UserContext';
import { apiUrl } from './config';
import { useLocation } from 'react-router-dom';
import trainersData from '../data/trainers.json';
import { Preferences } from '@capacitor/preferences';

const { Content } = Layout;
const { Option } = Select;

const RichiediSchedaPage = () => {
    const { user } = useUser();
    const location = useLocation();
    const [frequenza, setFrequenza] = useState('');
    const [selectedTrainer, setSelectedTrainer] = useState(null);
    const [note, setNote] = useState('');
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [form] = Form.useForm();

    // Preseleziona il trainer se presente nello stato della location
    useEffect(() => {
        if (location.state?.trainerId) {
            setSelectedTrainer(location.state.trainerId);
        }
    }, [location.state]);

    const checkPendingRequest = async () => {
        const token = (await Preferences.get({ key: 'token' })).value;
        try {
            const response = await axios.get(`${apiUrl}/api/workoutRequests/checkPending`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params: {
                    email: user.email,
                },
            });
            return response.data.pendingRequestExists;
        } catch (error) {
            console.error('Errore nel controllo delle richieste pendenti:', error.response?.data || error.message);
            return false;
        }
    };

    const handleSubmit = async () => {
        const token = (await Preferences.get({ key: 'token' })).value;
        if (!token) {
            message.error('Token mancante. Effettua di nuovo il login.');
            return;
        }

        const pendingExists = await checkPendingRequest();
        if (pendingExists) {
            setIsModalVisible(true);
            return;
        }

        submitRequest();
    };

    const submitRequest = async () => {
        setIsSubmitting(true);
        const token = (await Preferences.get({ key: 'token' })).value;
        try {
            await axios.post(`${apiUrl}/api/workoutRequests/request`, {
                frequenza,
                trainerId: selectedTrainer,
                note,
                email: user.email,
                nome: user.nome,
                cognome: user.cognome
            }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            message.success('Richiesta inviata con successo!');
            form.resetFields(); // Resetta tutti i campi del form
            setFrequenza('');
            setSelectedTrainer(null);
            setNote('');
        } catch (error) {
            console.error('Errore durante l\'invio della richiesta:', error.response?.data || error.message);
            message.error('Errore durante l\'invio della richiesta.');
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleConfirmNewRequest = async () => {
        setIsModalVisible(false);
        await submitRequest();
    };

    return (
        <Layout style={{ minHeight: '100vh' }}>
            <Content style={{ padding: '50px', maxWidth: '800px', margin: '0 auto' }}>
                <div className="dashboard-title">
                    RICHIEDI SCHEDA
                </div>
                
                <Form form={form} layout="vertical" onFinish={handleSubmit} style={{ marginTop: '2rem' }}>
                    <Row gutter={[16, 16]}>
                        <Col xs={24} sm={12}>
                            <Form.Item 
                                label={<span className="form-label">Frequenza Settimanale</span>}
                                name="Frequenza Settimanale"
                                rules={[{ required: true, message: 'Inserisci la frequenza settimanale!' }]} >
                                <Select value={frequenza} onChange={setFrequenza} placeholder="Seleziona frequenza">
                                    <Option value={1}>1 volta a settimana</Option>
                                    <Option value={2}>2 volte a settimana</Option>
                                    <Option value={3}>3 volte a settimana</Option>
                                    <Option value={4}>4 volte a settimana</Option>
                                    <Option value={5}>5 volte a settimana</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12}>
                            <Form.Item 
                                label={<span className="form-label">Scegli il tuo Trainer</span>}
                                rules={[{ required: true, message: 'Inserisci il trainer!' }]} >
                                <Select 
                                    value={selectedTrainer} 
                                    onChange={setSelectedTrainer} 
                                    placeholder="Seleziona un trainer"
                                    optionLabelProp="label"
                                >
                                    {trainersData
                                    .filter(trainer => ["1", "2", "3", "4", "5"].includes(trainer.id))
                                    .map(trainer => (
                                        <Option 
                                            key={trainer.id} 
                                            value={trainer.id} 
                                            label={trainer.name} 
                                            style={{ display: 'flex', alignItems: 'center' }}
                                        >
                                            <img 
                                                src={trainer.profileImage || '/images/trainer/default.jpg'} 
                                                alt={trainer.name} 
                                                style={{ 
                                                    width: '60px', 
                                                    height: '60px', 
                                                    marginRight: '10px', 
                                                    borderRadius: '8px', 
                                                    objectFit: 'contain' 
                                                }} 
                                            />
                                            <span>{trainer.name}</span>
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={24}>
                            <Form.Item 
                                label={<span className="form-label">Note Aggiuntive</span>}
                                name="Note Aggiuntive">
                                <Input.TextArea
                                    value={note}
                                    onChange={(e) => setNote(e.target.value)}
                                    placeholder="Inserisci eventuali note o preferenze"
                                    rows={4}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Button type="primary" htmlType="submit" block loading={isSubmitting}>
                        Invia Richiesta
                    </Button>
                </Form>

                <Modal
                    title="Richiesta Pendente"
                    open={isModalVisible}
                    onOk={handleConfirmNewRequest}
                    onCancel={() => setIsModalVisible(false)}
                    getContainer={document.body}
                    okText="Invia comunque"
                    cancelText="Annulla"
                    className="custom-modal"
                >
                    <p>Hai già una richiesta in sospeso. Sei sicuro di voler inviare una nuova richiesta?</p>
                </Modal>
            </Content>
        </Layout>
    );
};

export default RichiediSchedaPage;
